<template>
    <div class="addCategoriesComponent">
        <div v-if="loading" class="text-center">
            <v-progress-circular
                class="mt-auto"
                :size="70"
                :width="7"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </div>
        <div  v-else class="row">
            <div class="col-md-7">
                <v-form 
                    ref="form" 
                    lazy-validation 
                    class="mt-5 col-sm-8 col-md-8"
                    >
                    <v-text-field
                        :label="$t('board.label.table.nameCategory')"
                        color="secondary" 
                        v-model="formData.nombreCategoriaComercial"
                        readonly
                        disabled
                    ></v-text-field>
                    <v-text-field
                        :label="'*'+$t('board.label.nameSubCategory.title')" 
                        :placeholder="$t('board.label.nameSubCategory.text')" 
                        color="secondary"
                        v-model="formData.nombre"
                        :counter="25"
                        :maxlength="25"
                        :rules="subcategoryRules"
                        required
                    ></v-text-field>
                    <v-text-field
                        :label="'*'+$t('board.label.description.title')" 
                        :placeholder="$t('board.label.description.text')" 
                        color="secondary"
                        v-model="formData.descripcion"
                        :counter="40"
                        :maxlength="40"
                        :rules="descriptionRules"
                        required
                    ></v-text-field>
                    <v-text-field
                        :label="'*'+$t('board.label.mode.title')" 
                        color="secondary"
                        v-model="formData.nombreModo"
                        readonly
                        disabled
                    ></v-text-field>
                </v-form>
                <div class="img-btn">

                    <v-tooltip left>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                fab
                                fixed
                                bottom
                                right
                                dark
                                large
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                @click="submitForm"
                                >
                                <v-icon dark>mdi-content-save</v-icon>
                            </v-btn>

                        </template>

                        <span>{{ $t('button.save') }}</span>

                    </v-tooltip>  
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import Swal from "sweetalert2";
    import  EventBus  from '@/utils/event_bus.js'; 
    import { mapActions, mapGetters } from "vuex";
    import { 
        ACTION_POST_CREATE_SUBCATEGORIES,
        ACTION_GET_CATEGORIES_ID,
        GET_STATE_LOADING,
        GET_CATEGORIES_ID,
        ACTION_GET_MODE,
        GET_MODO,
        BOARD_M,
    } from "@/views/categories_board/store/types/types.js";
    import i18n from '@/plugins/i18n';

    export default {
        name:"addCategoriesComponent",
        props: {
            category: {
                required: true
            },
        },
        data() {
            
            return {
                formData: {
                    nombreCategoriaComercial:this.category.nombre,  
                    idCategoriaComercial: this.category.idCategoriaComercial,
                    nombre: '',
                    descripcion: '',
                    nombreModo: this.category.modo,
                    modo: null,    
                },
                subcategoryRules: [
                    v => !!v || this.$t('board.label.nameSubCategory.required')
                ],
                descriptionRules: [
                    v => !!v || this.$t('board.label.description.required')
                ],
                showErrorMessages: false
            };
        },

        async mounted() {
            // id del modo
            await this.getMode();
            const modos = await this.modes
            this.formData.modo = modos[1].idModoCategoria;

            EventBus.$on('reload-update-categories-sub', async ()  => {
                await this.getcategory(this.category.idCategoriaComercial);
                await this.updatecategory();
            });
            await this.getcategory(this.category.idCategoriaComercial);
            EventBus.$on('clear-subcategories-form', this.clearForm);
        },

        beforeDestroy() {
            // Limpiar el event listener
            EventBus.$off('clear-subcategories-form', this.clearForm);
        },

        methods: {

            ...mapActions({
                getMode: `${BOARD_M}${ACTION_GET_MODE}`,
                putUpdateSubCategoria: `${BOARD_M}${ACTION_POST_CREATE_SUBCATEGORIES}`,
                getcategory: `${BOARD_M}${ACTION_GET_CATEGORIES_ID}`,

            }),

            updatecategory(){
                this.formData.nombreCategoriaComercial = this.categoryConsult.nombre
            },

            async submitForm() {
                // Validar el formulario antes de enviarlo
                const validationErrors = this.validateForm();

                // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
                if (Object.keys(validationErrors).length > 0) {
                    const errorMessages = Object.values(validationErrors).join('<br>');
                    Swal.fire({
                        icon: 'error',
                        title: i18n.t('label.errorsValidation.plural.title'),
                        html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
                        confirmButtonColor: '#6E17A5'
                    });
                    return;
                }

                // Si no hay errores de validación, imprime el formulario en la consola
                const save = this.putUpdateSubCategoria(this.formData);
                if(!save){
                    return Swal.fire({
                        icon: 'error',
                        title: i18n.t('label.invalid.title'),
                        text: i18n.t('label.invalid.text')
                    })

                }

                await this.clearForm();
                EventBus.$emit('formSub-submitted-successfully');
                
            },

            clearForm() {
                // Resetear formData
                this.formData = {
                    nombreCategoriaComercial: this.category.nombre,
                    idCategoriaComercial: this.category.idCategoriaComercial,
                    nombre: '',
                    descripcion: '',
                    nombreModo: this.category.modo,
                    modo: null,
                };
                
                // Resetear validación del formulario
                if (this.$refs.form) {
                    this.$refs.form.reset();
                }
            },

            validateForm() {
                this.showErrorMessages = true;

                const errors = {};

                if (!this.formData.nombre || !this.formData.nombre.trim()) {
                    errors.nombre = this.$t('board.label.nameSubCategory.title');
                }

                if (!this.formData.descripcion || !this.formData.descripcion.trim()) {
                    errors.descripcion = this.$t('board.label.description.title');
                }
                
                return errors;
            },

          
        },

        computed: {

            ...mapGetters({
                modes: `${BOARD_M}${GET_MODO}`,
                loading: `${BOARD_M}${GET_STATE_LOADING}`,
                categoryConsult: `${BOARD_M}${GET_CATEGORIES_ID}`,
            }),

        },

    };

</script>


<style lang="css" scoped>

        input[type="file"] {
            left: 0;
            top: 0;
            opacity: 0;
            width: 100%;
            height: 100%;
        }

    /* Css input imagen*/

    .col-md-7 {
        display: flex;
        justify-content: center;
        align-items: center;
        gap:230px;
    }
    .row {
        display: flex;
        justify-content: center;
    }


    /*Resposive*/
    @media screen and (min-width: 912px) {
    .col-md-7 {
        gap: 90px
    }
    }

    @media screen and (max-width: 768px) {
        .col-md-7 {
            gap: 25px;
        }
    }
    @media screen and (max-width: 425px) {
        .col-md-7 {
            
            display: flex;
            flex-direction: column-reverse;
            gap: 25px;
        } 
    }

</style>